const contentOverlay = document.querySelector("#content-overlay");

/**
 * Helper function to toggle the content overlay.
 * @param {boolean} visible Should the overlay get visible or not
 */
export function toggleContentOverlay(visible = false) {
    if (contentOverlay) {
        if (visible) {
            contentOverlay.classList.add("visible");
            // contentOverlay.style.transitionDelay = "0s";
            contentOverlay.setAttribute("aria-hidden", "false");
        } else {
            contentOverlay.classList.remove("visible");
            // contentOverlay.style.transitionDelay = "0.15s";
            contentOverlay.setAttribute("aria-hidden", "true");
        }
    }
}